import React from "react";
import "../../stylesheets/_home.sass";
import IndexAdminCard from "./indexAdminCard";
import IndexTranscriberCard from "./indexTranscriberCard";
import IndexLeaderboardCard from "./indexLeaderboardCard";
import IndexScorerCard from "./indexScorerCard";
import IndexSecondPassTranscriptionQueue from "./indexSecondPassTranscriptionQueue";
import IndexTranscriberBonus from "./indexTranscriberBonus";
import IndexTransactionQaQueue from "./indexTransactionQaQueue";
import IndexTranscriptionQueue from "./indexTranscriptionQueue";
import IndexScoringErrors from "./indexScoringErrors";
import IndexScoringFeedback from "./indexScoringFeedback";
import IndexScoringQueue from "./indexScoringQueue";
import CallReservationModule from "./callReservationModule";
import SiteSummary from "./siteSummary";

import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import CallsWebsocket from "../../lib/callsWebsocket";
import { sendAPIRequest } from "shared/utils/requests";
import _ from "lodash";

export default class Home extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      queue: [],
      totalCount: 0,
      claimingCall: false,
    };

    this.updateQueueThrottled = this.updateQueueThrottled.bind(this);
  }

  componentDidMount() {
    const { queueAuthToken, instacallUrl } = this.props;
    this.websocket = new CallsWebsocket(
      instacallUrl,
      queueAuthToken,
      callIds => {
        const { queue } = this.state;
        let callsIdObject = Object.fromEntries(callIds.map(id => [id, true]));
        this.setState({
          queue: queue.filter(item => !callsIdObject[item.call_id]),
        });
      }
    );
    this.websocket.connect().then(this.updateQueueThrottled);
    this.interval = setInterval(this.updateQueueThrottled, 3500);
  }

  componentWillUnmount() {
    this.websocket.close();
    clearInterval(this.interval);
  }

  updateQueue = async () => {
    try {
      const queue = await this.websocket.getQueue();
      this.setState({ totalCount: queue.totalCount, queue: queue.calls });
    } catch (e) {
      // connection failed for some reason or we tried to update the queue more than once
      console.error(e);
    }
  };

  updateQueueThrottled = _.throttle(this.updateQueue, 500);

  claimCall = async callId => {
    const { claimingCall } = this.state;
    if (claimingCall) {
      return;
    }
    this.setState({ claimingCall: true });
    try {
      const {
        status,
        callId: returnedCallId,
        auth,
      } = await this.websocket.claimCall(callId);
      if (status == "success" && callId == returnedCallId) {
        const response = await sendAPIRequest(
          `/transcriptions/${callId}/claim`,
          "POST",
          { auth }
        );
        if (response.status == 200) {
          window.location.href = `/transcriptions/${callId}`;
        } else {
          this.setState({ claimingCall: false });
          if (response.status == 400) {
            alert("Failed to claim call, please try another call!");
          } else if (response.status == 403) {
            alert("You've claimed too many calls. Select an existing call");
          } else {
            throw new Error(
              "invalid return status for transcript claim: " + response.status
            );
          }
        }
      } else {
        this.setState({ claimingCall: false });
        alert("Failed to claim call, please try another call!");
      }
    } catch (e) {
      this.setState({ claimingCall: false });
      console.error(e);
      alert("Failed to claim call, please try again shortly!");
    }
  };

  claimCallReservation = async (callId, auth) => {
    const response = await sendAPIRequest(
      `/transcriptions/${callId}/claim`,
      "POST",
      { auth }
    );
    if (response.status == 200) {
      window.location.href = `/transcriptions/${callId}`;
    } else {
      this.setState({ claimingCall: false });
      if (response.status == 400) {
        alert("Failed to claim call, please try another call!");
      } else if (response.status == 403) {
        alert("You've claimed too many calls. Select an existing call");
      } else {
        throw new Error(
          "invalid return status for transcript claim: " + response.status
        );
      }
    }
  };

  render() {
    const {
      currentContractor,
      defaultCompanyId,
      topTranscribers,
      weekStart,
      weekEnd,
      bonus,
      transcriptionSecondPassQueue,
      transcriptionQaQueue,
      transcriptionQueue,
      companyResponses,
      companyFeedback,
      siteSummary,
      callbackSchedulingQaNum,
      pendingTranscripts,
      availableTranscripts,
    } = this.props;

    const { queue, totalCount, claimingCall } = this.state;

    const contractorUser = currentContractor.currentContractor;
    const admin = contractorUser.admin;
    const transcriber = contractorUser.transcribe_only;
    const scorer = !contractorUser.transcribe_only;

    let navCard;

    if (admin) {
      navCard = (
        <IndexAdminCard
          contractorId={contractorUser.id}
          defaultCompanyId={defaultCompanyId}
        />
      );
    } else if (transcriber) {
      navCard = <IndexTranscriberCard contractorId={contractorUser.id} />;
    } else {
      navCard = (
        <IndexScorerCard
          currentContractor={contractorUser}
          defaultCompanyId={defaultCompanyId}
        />
      );
    }

    return (
      <Container fluid="md">
        <Row>
          <Col md={4} xs={12}>
            {navCard}
          </Col>
          {(admin || transcriber) && (
            <Col md={8} xs={12}>
              <IndexLeaderboardCard
                topTranscribers={topTranscribers}
                currentContractor={contractorUser}
                weekStart={weekStart}
                weekEnd={weekEnd}
              />
            </Col>
          )}
        </Row>

        {transcriber && !admin && (
          <Row>
            <Col>
              <IndexTranscriberBonus
                transcribeOnly={transcriber}
                nextTarget={bonus.nextTarget}
                minutesRemaining={bonus.minutesRemaining}
                targetClass={bonus.targetClass}
                minutesThisWeek={bonus.minutesThisWeek}
                percentToNextTarget={bonus.percentToNextTarget}
              />
            </Col>
          </Row>
        )}

        {/* show to top 200 and super users only */}
        {(contractorUser.top_200 || contractorUser.role.id == 1) && (
          <CallReservationModule
            claimCall={this.claimCallReservation}
            currentlyEditing={transcriptionQueue.currentlyEditing}
          />
        )}

        {admin && (
          <Row id="tqr">
            <Col>
              <IndexTransactionQaQueue
                queueLength={transcriptionQaQueue.queue_length}
                inProgressCount={transcriptionQaQueue.in_progress_count}
                currentlyQaing={transcriptionQaQueue.currently_qaing}
                completedToday={transcriptionQaQueue.completed_today}
              />
            </Col>
          </Row>
        )}

        {(admin || transcriber) && (
          <Row>
            <Col>
              <IndexTranscriptionQueue
                currentlyEditing={transcriptionQueue.currentlyEditing}
                currentContractor={contractorUser}
                updateQueueThrottled={this.updateQueueThrottled}
                queue={queue}
                totalCount={totalCount}
                claimingCall={claimingCall}
                claimCall={this.claimCall}
              />
            </Col>
          </Row>
        )}

        {transcriptionSecondPassQueue.show_queue && (
          <Row>
            <Col>
              <IndexSecondPassTranscriptionQueue
                queueLength={transcriptionSecondPassQueue.queue_length}
                inProgressCount={transcriptionSecondPassQueue.in_progress_count}
                currentlyTranscribing={
                  transcriptionSecondPassQueue.currently_transcribing
                }
                completedToday={transcriptionSecondPassQueue.completed_today}
              />
            </Col>
          </Row>
        )}

        {(admin || scorer) && (
          <>
            <Row>
              <Col>
                <IndexScoringErrors
                  companyResponses={companyResponses}
                  currentContractorId={contractorUser.id}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <IndexScoringFeedback
                  companyFeedback={companyFeedback}
                  currentContractorId={contractorUser.id}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <SiteSummary
                  siteSummary={siteSummary}
                  admin={admin}
                  callbackSchedulingQaNum={callbackSchedulingQaNum}
                />
              </Col>
            </Row>
            <Row>
              <Col>
                <IndexScoringQueue
                  siteSummary={siteSummary}
                  admin={admin}
                  callbackSchedulingQaNum={callbackSchedulingQaNum}
                  pendingTranscripts={pendingTranscripts}
                  availableTranscripts={availableTranscripts}
                  currentContractor={contractorUser}
                />
              </Col>
            </Row>
          </>
        )}
      </Container>
    );
  }
}
